import request from './request';

/**
 * @param body
 * @returns {Promise<any>}
 */
function submitClaim(body) {
    const options = {
        endpoint: '/claims',
        method: 'POST',
        noJson: true,
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param claimID
 * @returns {Promise<any>}
 */
function getClaimSummary(claimID) {
    const options = {
        endpoint: `/claims/${ claimID }/summary`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param claimID
 * @returns {Promise<any>}
 */
function getClaims(filters, sort) {
    const options = {
        endpoint: `/getClaims`,
        method: 'POST',
        body: {
            filters,
            sort
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param claimID
 * @returns {Promise<any>}
 */
function sendClaimApprovalEmail(claimID) {

    const options = {
        endpoint: `/claims/${ claimID }/email/approval`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * 
 * @param {*} dateRange 
 * @returns 
 */
function createClaimsSummaryReport(dateRange, category, service) {
    const options = {
        endpoint: `/claims/claimsSummaryReport`,
        method: 'POST',
        body: {
            dateRange,
            category,
            service
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

export {
    submitClaim,
    getClaimSummary,
    getClaims,
    sendClaimApprovalEmail,
    createClaimsSummaryReport
};